import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HospitalStateService } from './hospitalstate.service';

@Injectable({ providedIn: 'root' })
export class IpdFeatureService {
  private _isEnabled = false;
  
  constructor(private _hospitalState: HospitalStateService) {
    // keep value updated when login sets hospital
    this._hospitalState.hospital$
      .subscribe(hospital => {
        this._isEnabled = !!hospital?.isIPD;
      });
  }

  get isEnabled$(): Observable<boolean> {
    return this._hospitalState.hospital$.pipe(
      map(hospital => !!hospital?.isIPD)
    );
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }
}
